/**
 * Util para generar un reducer funcional a través de un Map, de esta manera
 * evitar el uso de switch;
 */
const createReducer = initialState => reducerMap => (state = initialState, action) => {
  const reducer = reducerMap[action.type];
  return reducer ? reducer(state, action) : state;
};

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

/**
 * Util para crear un shallowEqual de una lista de propiedades
 * usable en el hook useSelector(selector, shallowEqual('prop1', 'prop2', ...))
 */
const shallowEqualOf = (...props) => (prev, next) => {
  if (is(prev, next)) {
    return true;
  }
  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }
  for (let i = 0; i < props.length; i++) {
    const prop = props[i];
    if (!is(prev[prop], next[prop])) {
      return false;
    }
  }
  return true;
};

export { createReducer, shallowEqualOf };
